import { Text, Table, Stack } from "@mantine/core"
import { ReminderDetailDrawerProps } from "../reminder-detail-drawer"
import { useTranslation } from "react-i18next"
import { PersonNameWithUserNameFallback } from "../../chat/ChatListForCurrentUser/PersonNameWithUserNameFallback"
import { getFormattedDate } from "@/utils/get-formatted-date"

export const ReminderViewDetailDrawer: React.FC<ReminderDetailDrawerProps> = ({
  reminder,
}) => {
  const { t } = useTranslation()

  return (
    <Stack>
      <Table striped highlightOnHover>
        <Table.Tbody>
          <Table.Tr>
            <Table.Td style={{ minWidth: 160 }}>
              <Text fw={500}>{t("ReminderFor")}</Text>
            </Table.Td>
            <Table.Td>
              {reminder.userId ? (
                <PersonNameWithUserNameFallback userId={reminder.userId} />
              ) : (
                "-"
              )}
            </Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td style={{ minWidth: 160 }}>
              <Text fw={500}>{t("Content")}</Text>
            </Table.Td>
            <Table.Td>
              <Text>{reminder.text}</Text>
            </Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td style={{ minWidth: 160 }}>
              <Text fw={500}>{t("DueDate")}</Text>
            </Table.Td>
            <Table.Td>
              <Text>
                {reminder.time ? getFormattedDate(reminder.time) : "-"}
              </Text>
            </Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td style={{ minWidth: 160 }}>
              <Text fw={500}>{t("Completed")}</Text>
            </Table.Td>
            <Table.Td>
              <Text>{reminder.completed ? t("Yes") : t("No")}</Text>
            </Table.Td>
          </Table.Tr>
        </Table.Tbody>
      </Table>
    </Stack>
  )
}
